export default "__VITE_ASSET__65c602f4__"